import BasicDashboardCard from '@sophocles/components/BasicDashboardCard/BasicDashboardCard';

export default BasicDashboardCard;
